class OrderCalculator extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            inputAll: this.querySelectorAll('input, select, textarea'),
            result: this.querySelector('#recommended_amount'),
            units: this.querySelector('[data-units]'),
            link: this.querySelector('[data-link]'),
        };
        this.onChange = this.onChange.bind(this);
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.selectors.inputAll.forEach((input) => {
            input.addEventListener('change', this.onChange.bind(this));
            input.addEventListener('input', this.onChange.bind(this));

        });
    }
    configSettings() {
        this.setings = {
            type: this.querySelector('select[name="type"]').value, // Colour Powder || Slime
            number: this.querySelector('input[name="Expected Number of People"]').value, // Number of people
        };
    }
    onChange() {
        this.configSettings();

        let muliplier = this.setings.type === 'Colour Powder' ? 0.15 : 1.5;
        // Converting to x100 and /100 to get the correct value whithoutt decimals;
        muliplier *= 100;
        this.selectors.result.value = (parseInt(this.setings.number) * muliplier / 100);
        this.selectors.units.innerHTML = this.setings.type === 'Colour Powder' ? 'Kilogram/s' : 'Litre/s';
        this.selectors.link.href = this.setings.type === 'Colour Powder' ? '/collections/colour-powder' : '/collections/slime-mud';
    }
}
customElements.define('order-calculator', OrderCalculator);
